import React from 'react';
import { ToggleSection } from '@/components/form/ToggleSection';
import { FeeAmountFieldset } from './FeeAmountFieldset';
import { NumberInputRow } from '@/components/form/NumberInputRow';

interface EarlyPaymentSectionProps {
  localUseEarlyPaymentDiscount: boolean;
  localEarlyPaymentType: 'percentage' | 'fixed';
  shouldShowEarlyPaymentDaysInput: boolean;
  earlyDiscountPctProps?: Record<string, unknown>;
  earlyDiscountPctError?: React.ReactNode;
  earlyDiscountFixedProps?: Record<string, unknown>;
  earlyDiscountFixedError?: React.ReactNode;
  earlyDaysProps?: Record<string, unknown>;
  earlyDaysError?: React.ReactNode;
  onToggleEarlyPayment: (checked: boolean) => void;
  onEarlyPaymentTypeChange: (type: 'percentage' | 'fixed') => void;
}

export const EarlyPaymentSection: React.FC<EarlyPaymentSectionProps> = ({
  localUseEarlyPaymentDiscount,
  localEarlyPaymentType,
  shouldShowEarlyPaymentDaysInput,
  earlyDiscountPctProps,
  earlyDiscountPctError,
  earlyDiscountFixedProps,
  earlyDiscountFixedError,
  earlyDaysProps,
  earlyDaysError,
  onToggleEarlyPayment,
  onEarlyPaymentTypeChange,
}) => {
  return (
    <ToggleSection
      id="useEarlyPaymentDiscount"
      label="Apply Early Payment Discount"
      description="Offer a discount for paying before due date"
      checked={localUseEarlyPaymentDiscount}
      onCheckedChange={onToggleEarlyPayment}
      variant="indented"
    >
      <FeeAmountFieldset
        type={localEarlyPaymentType}
        onTypeChange={onEarlyPaymentTypeChange}
        percentageInputProps={earlyDiscountPctProps}
        percentageErrorElement={earlyDiscountPctError}
        fixedInputProps={earlyDiscountFixedProps}
        fixedErrorElement={earlyDiscountFixedError}
        idPrefix="ep"
        percentageLabel="Rate Percentage"
        fixedLabel="Discount Amount"
      />
      {shouldShowEarlyPaymentDaysInput && (
        <NumberInputRow
          id="earlyPaymentDays"
          label="Days for Early Payment Discount"
          description="How many days before due date to apply the discount"
          unit="days"
          unitPosition="right"
          placeholder="e.g. 10"
          inputProps={earlyDaysProps ?? {}}
          errorElement={earlyDaysError}
          className="animate-fade-in"
        />
      )}
    </ToggleSection>
  );
};
